import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubCategoryPageRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-category-page',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId',
};
